module.exports = __webpack_public_path__ + "static/img/greenretreats_tg03.757e204.jpg";